module.exports = __webpack_public_path__ + "static/img/mylogo.3e80045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mylogo.png
// module id = CUkX
// module chunks = 7